/* eslint-disable import/prefer-default-export */
export const es = {
  translation: {
    title: 'Validar copia autorizada electrónica',
    desc:'Introduce el CSV (Código Seguro de Verificación) y pulsa el botón Validar para comprobar la autenticidad e integridad de la copia autorizada electrónica del documento notarial, así como conocer las notas ulteriores de modificación jurídica y de coordinación con otros instrumentos públicos.',
    placeholderCSV:'Código CSV',
    validateButton: 'Validar',
    backButton:'Volver',
    okButton:'Aceptar',
    cancelButton:'Cancelar',
    closeButton:'Cerrar',
    actionsButton:'Acciones',
    downloadButton:'Descargar',
    head:{
      title: 'SEDE ELECTRÓNICA NOTARIAL',
    },
    footer:{
      legalNotice: 'Aviso Legal',
      privacyPolicy: 'Política de privacidad',
      accessibility: 'Accesibilidad',
      cookiesPolicy: 'Política de cookies',
      supportedBrowsers: 'Navegadores soportados',
    },
    modalsupportedbrowsers:{
      other: 'Puedes acceder utilizando un PC, Mac, móvil o tableta.',
    },
    actions: {
      helpButton:'Ver ayuda',
      validateSignature:'Validar firma',
      download:'Descargar',
      downloadCombined: 'Descargar unidos'
    },
    modalAyuda:{
      title:'Ayuda',
      guide:'Aquí puedes descargar la guía relacionada con esta sección',
      section1: 'Comprobar la validez de la firma mediante la Sede Electrónica Notarial',
      desc1: 'Para comprobar la validez de la firma electrónica cualificada del notario en el documento notarial, haz clic en el botón <strong>Acciones</strong> y selecciona la opción <strong>Validar firma</strong>.',
      section2: 'Comprobar la validez de la firma mediante Adobe Acrobat Reader',
      desc2: 'Para comprobar la validez de la firma electrónica cualificada del notario en el documento notarial, haz clic en el botón <strong>Acciones</strong> y selecciona la opción <strong>Descargar</strong>. Después, abre el documento con Adobe Acrobat Reader y haz clic en el icono de la pluma situado en el menú lateral. <br /><br /> En la lista desplegable podrás comprobar la validez de la firma y analizar sus detalles.',
      section3: 'Comprobar la validez de la firma mediante VALIDe',
      desc3: 'Para comprobar la validez de la firma electrónica cualificada del notario en el documento notarial, haz clic en el botón <strong>Acciones</strong> y selecciona la opción <strong>Descargar</strong>. Después, utiliza la',
      linkText: 'plataforma pública VALIDe',},
      modalCopia:{
      title:'Copia autorizada electrónica',
    },
    modalErrorServicio:{
      desc: 'No existe ninguna copia autorizada electrónica vinculada al código CSV que has introducido. Por favor, revisa el código e inténtalo de nuevo. ',
      contactSupport: 'Si sigues teniendo problemas puedes ponerte en contacto con el servicio de soporte.',
    },
    modalAdvertenciaDescarga:{
      title:'Advertencia',
      desc:'<strong>Las notas</strong> de modificación jurídica y de coordinación con otros instrumentos públicos <strong>emitidas después de la expedición de la copia no estarán disponibles en el documento que va a descargar.</strong> Solo figuran en el justificante de expedición de la copia.',
    },
    modalErrorGenerico:{
      desc:'Ha ocurrido un problema. Intentelo de nuevo.',
    },
    modalErrorValidacion:{
      title:'Error en la validación de la firma.',
      desc:'No se pudo validar la firma del documento. Por favor, inténtalo de nuevo o contacta con el servicio de soporte.',
    },
    modalManuales:{
      name:'Nombre',
    },
    modalValidacionFirma:{
      title:'Validar firma',
      firmaNotario:'FIRMA CUALIFICADA DEL NOTARIO:',
      fechaFirma:'FECHA DE LA FIRMA:',
      fechaValidacion:'FECHA DE LA VALIDACIÓN:',
      estadoFirma:'ESTADO DE LA FIRMA:',
      validacionFirma:'Validación de firma electrónica del Consejo General del Notariado',
      validada:'Validada',
      noValidada:'No válida',
      contenido:'Contenido del documento',
      alterado:'alterado',
      noAlterado:'no alterado',
      certificadoFirmante:'Certificado firmante',
      caducado:'caducado',
      noCaducado:'no caducado',
      revocado:'revocado',
      noRevocado:'no revocado',
      certificadoCa:'emitido por una autoridad de certificación de confianza (CA)',
      noCertificadoCa:'no emitido por una CA de confianza',
    },
  },
};
